<script lang="ts">
    import { get } from "svelte/store";
    import {
        getHtmlFragmentLoaderForTargetId,
        getHtmlFragmentLoaderForTargetIdIfExists,
    } from "./HtmlFragmentLoader.store";
    import HtmlFragmentLoader from "./HtmlFragmentLoader.svelte";
    import HtmlFragmentLoaderActivator from "./HtmlFragmentLoaderActivator.svelte";
    let index = 0;
    function getKeyForFragmentLoaderTarget() {
        return "fragment_loader_target_" + index++;
    }

    function gotFragmentLoaderClick(activator: HTMLElement, targetElement: HTMLElement) {

        let fragmentLoaderScrollTo = undefined;
        if (targetElement) {
            fragmentLoaderScrollTo = targetElement.dataset['fragmentLoaderScrollTo'];
        }

        if (activator.dataset.htmlFragmentLoaderActivatorAttached === "true") {
            return;
        }

        const urlToFetch = activator.dataset.fragmentUrl;
        if (!urlToFetch) {
            return;
        }

        let targetElementCandidate: HTMLElement | undefined;
        let targetId = activator.dataset.fragmentTarget;
        if (targetId) {
            targetElementCandidate = document.querySelector<HTMLElement>(
                activator.dataset.fragmentTarget
            );
            if (!targetElementCandidate) {
                return;
            }
        } else {
            targetId = getKeyForFragmentLoaderTarget();
        }

        if (!targetElementCandidate) {
            targetElementCandidate = document.createElement("div");
            targetElementCandidate.id = targetId;
            activator.parentElement.appendChild(targetElementCandidate);
        }

        let htmlFragmentLoader: HtmlFragmentLoader | undefined = (
            targetElementCandidate as any
        ).htmlFragmentLoader;

        if (!htmlFragmentLoader) {
            const htmlWhenHidden = targetElementCandidate.innerHTML;
            targetElementCandidate.innerHTML = "";
            htmlFragmentLoader = new HtmlFragmentLoader({
                target: targetElementCandidate,
                props: {
                    targetId,
                    htmlWhenHidden: htmlWhenHidden,
                    showHideButton:
                        activator.dataset.fragmentHideButton === "true",
                    url: urlToFetch,
                    targetElement: targetElementCandidate,
                },
            });
            (targetElementCandidate as any).htmlFragmentLoader =
                htmlFragmentLoader;
        }
        if (fragmentLoaderScrollTo) {
            htmlFragmentLoader.unregisterLoadedEvent =
                htmlFragmentLoader.$on("loaded", () => {
                    const element = document.querySelector(fragmentLoaderScrollTo);
                    if (element) {
                        let offsetY = window.pageYOffset + element.getBoundingClientRect().top;
                        window.scrollTo({top: offsetY});
                    }
                });
        } else {
            if (htmlFragmentLoader.unregisterLoadedEvent) {
                htmlFragmentLoader.unregisterLoadedEvent();
            }
        }
        /*
        new HtmlFragmentLoaderActivator({
            target: activator,
            props: {
                url: urlToFetch,
                targetId,
                activatorElement: activator,
            },
        });*/

        getHtmlFragmentLoaderForTargetId(targetId).set(urlToFetch);
    }

    function closeFragmentIfOpen(element: HTMLElement) {
        let targetSelector = element.dataset["fragmentTarget"];
        if (!targetSelector) {
            const parentWithFragmentTarget = element.closest<HTMLElement>(
                "[data-fragment-target]"
            );
            if (parentWithFragmentTarget) {
                targetSelector =
                    parentWithFragmentTarget.dataset["fragmentTarget"];
            }
        }
        const loaderUrl =
            getHtmlFragmentLoaderForTargetIdIfExists(targetSelector);
        if (loaderUrl.isPresent) {
            const currentUrl = get(loaderUrl.data);
            if (currentUrl) {
                loaderUrl.data.set(null);
                return true;
            }
        }
        return false;
    }

    let selectionOnMouseDown: string;
    document.addEventListener("mousedown", () => {
        selectionOnMouseDown = window.getSelection().toString();

    });

    document.addEventListener("click", (clickEvent: Event) => {
        const selectionAfterClick = window.getSelection();

        if (selectionOnMouseDown + "" !== selectionAfterClick + "") {
            // selection has changed, so there is a text selected, don't load fragment
            return;
        }

        const targetElement = clickEvent.target;
        function checkIfElementOrParentMeetsCriteria(element: HTMLElement) {
            if (!element) {
                return;
            }
            if (element.matches("[data-fragment-activator=nopropagation]")) {
                return;
            }
            if (element.matches("[data-fragment-close-on-click]")) {
                if (closeFragmentIfOpen(element)) {
                    return;
                }
            }
            if (
                element.matches("[data-element=fragment-loader]") ||
                element.matches("[data-fragment-loader=true]")
            ) {
                gotFragmentLoaderClick(element, targetElement as HTMLElement);
                return;
            }
            if (element.matches("[data-element=fragment-loader-content]")) {
                return;
            }

            // stop processing if this element is clickable (cursor = pointer, button or anchor)
            if (
                element.style.cursor === "pointer" ||
                element.tagName === "BUTTON" ||
                element.tagName === "A"
            ) {
                return;
            }

            if (element.parentElement !== null) {
                checkIfElementOrParentMeetsCriteria(element.parentElement);
                return;
            }
        }

        if (targetElement instanceof HTMLElement) {
            checkIfElementOrParentMeetsCriteria(targetElement);
        }
    });
</script>
